import { useDeviceType } from '@cian/ui-kit';

import { type FC } from 'react';

import { type TSpecialProjectBannerContext } from 'shared/types/bannerContext';
import { useAdfoxBannerContext } from 'shared/components/AdfoxBannerContext';

import { SpecialProjectDesktop } from './internal/components/SpecialProjectDesktop';
import { SpecialProjectMobile } from './internal/components/SpecialProjectMobile';

type TSpecialProjectContainerProps = {
  context: TSpecialProjectBannerContext;
};

/**
 * Контейнер баннера спецпроекта (`special_project_banner`).
 *
 * Объединяет реализации из двух проектов и выбирает верстку по типу устройства:
 * - desktop — frontend-serp (NewbuildingSpecialProject)
 * - phone/tablet — mobile-search-frontend (NewbuildingSpecialProject/SpecialProjectBanner)
 */
export const SpecialProjectContainer: FC<TSpecialProjectContainerProps> = ({ context }) => {
  const deviceType = useDeviceType();

  const { sizes } = useAdfoxBannerContext();

  if (deviceType === 'desktop') {
    return <SpecialProjectDesktop context={context} sizes={sizes} />;
  }

  return <SpecialProjectMobile context={context} height={sizes.height} />;
};
